
import Router from "./router";
import { HashRouter } from "react-router-dom";
import { AppProvider } from "./context/AppContext";


function App() {

  return (
    <AppProvider>
      <Router history={HashRouter} />      
    </AppProvider>
  );
}

export default App;
